import ApiServices from '@/services/api'

const state = {
  logData: {}
}

const getters = {
  logData: state => state.logData
}

const mutations = {
  setLogs (state, response) {
    state.logData = response.data
  }
}

const actions = {
  FETCH_LOGS ({ commit }, params) {
    return ApiServices.getLogs(params).then(response => {
      commit('setLogs', response)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/logs/index.js